import { render, staticRenderFns } from "./AxesPanel.vue?vue&type=template&id=8820a94c&scoped=true"
import script from "./AxesPanel.vue?vue&type=script&lang=js"
export * from "./AxesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8820a94c",
  null
  
)

export default component.exports